export const StoreConsts = {
  STATUS_ACTIVE: 1,
  STATUS_INACTIVE: 2,
  getStatusName: (status: number): string => typeof statuses[status] != 'undefined' ? statuses[status] : ''
}

export const STORE_STATUS_OPTIONS = [
  {label: 'common.all', value: ''},
  {label: 'common.active', value: StoreConsts.STATUS_ACTIVE},
  {label: 'common.inActive', value: StoreConsts.STATUS_INACTIVE},
]

const statuses: Record<number, string> = {
  [StoreConsts.STATUS_ACTIVE]: 'Hoạt động',
  [StoreConsts.STATUS_INACTIVE]: 'Không hoạt động'
}


export interface IBusiness {
  id: number;
  name: string;
  email: string;
  status: number;
}

export interface IBusinessOption {
  id: number,
  name: string,
  roleId?: string,
  pageIds: string[],
  pages?: any[],
  avatar?: string,
  /** Cờ đánh dấu doanh nghiệp được nạp tạm thời bởi Admin impersonate (không phải login gốc) */
  isImpersonated?: boolean,
}

export interface IBusinessSuggest {
  id: string;
  name: string;
  email: string;
  phone: string;
  createdTime: number
}
